// Paket 08 Schritt 6 (EIN-06, EIN-07): Wörter der Liste „Angemeldete Geräte“ im Bereich Sicherheit, ohne React, damit
// frontend/tests/einstellungen-seiten.test.mjs sie ohne Browser prüft.
import { datumZeit } from '../../utils/datum';

// Browser und System aus der Browserkennung. Die Reihenfolge zählt: Edge und Opera nennen auch Chrome, Chrome nennt auch
// Safari, iPhone und iPad nennen auch Mac OS X, Android nennt auch Linux.
const BROWSER: [RegExp, string][] = [[/Edg(e|A|iOS)?\//, 'Edge'], [/OPR\/|Opera/, 'Opera'], [/Firefox\/|FxiOS\//, 'Firefox'],
  [/Chrome\/|CriOS\//, 'Chrome'], [/Safari\//, 'Safari']];
const SYSTEM: [RegExp, string][] = [[/iPhone|iPad|iPod/, 'iOS'], [/Windows/, 'Windows'], [/Android/, 'Android'],
  [/Mac OS X|Macintosh/, 'macOS'], [/CrOS/, 'ChromeOS'], [/Linux/, 'Linux']];

export function geraetName(kennung: string | null | undefined): string {
  if (!kennung) return 'Unbekanntes Gerät';
  const browser = BROWSER.find(([muster]) => muster.test(kennung))?.[1];
  const system = SYSTEM.find(([muster]) => muster.test(kennung))?.[1];
  return browser && system ? `${browser} unter ${system}` : browser ?? system ?? 'Unbekanntes Gerät';
}

// Profil-Nachbau F-02 (F-PR-1, BAU-EINSTELLUNGEN.md B5.3): jede Anfrage prüft ihre Sitzung, ein beendetes Gerät ist deshalb
// sofort abgemeldet; der Satz nennt keine Frist mehr.
export const ABMELDE_SATZ = 'Das Gerät ist abgemeldet.';

// B5.2: der Abschnitt „Angemeldete Geräte“ unter „Sicherheit“; „Geräte ansehen“ im Profil springt dorthin. Steht hier statt in
// seiten.ts, solange diese Datei gesperrt ist (Frage F-L1).
export const GERAETE_ANKER = 'angemeldete-geraete';

export const zeitpunkt = (wert: string) => datumZeit(wert);
